export const providerNoteState = {
  isSpeechRecognizing: false,
  providerNotesExpanded: true,
  providerNotesTouched: false,
  providerNoteSubmitting: false,
  providerNoteSubmittingAndProcessing: false,
  providerNoteSubmittingAndSigningAndProcessing: false,
  providerNoteSubmittingAndSigningAndUnProcessing: false,
  providerNotes: "",
  originalProviderNotes: "",
};
